"use client";

// Dependencies
import Link from "next/link";

// Components
import {
  Form,
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import Captcha from "@/components/accounts/Captcha";
import { Toaster } from "@/components/ui/toaster";
import { PasswordInput } from "@/components/common/forms/PasswordInput";

// Controllers
import useLoginController from "../controllers/login.controller";

const LoginForm = () => {
  const { isPending, form, handleSubmit, captchaResolved, handleCaptcha } =
    useLoginController();

  return (
    <>
      <Toaster />
      <h2 className="font-bold text-2xl mb-4">Inicia sesión</h2>

      <Form {...form}>
        <form
          onSubmit={form.handleSubmit(handleSubmit)}
          className="w-full mb-4"
          autoComplete="off"
        >
          <FormField
            control={form.control}
            name="correo"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Correo</FormLabel>
                <FormControl>
                  <Input
                    type="email"
                    placeholder="Correo"
                    {...field}
                    autoComplete="off"
                  />
                </FormControl>
                <FormDescription></FormDescription>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="pwd"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Contraseña</FormLabel>
                <FormControl>
                  <PasswordInput
                    placeholder="Contraseña"
                    {...field}
                    autoComplete="off"
                  />
                </FormControl>
                <FormDescription></FormDescription>
                <FormMessage />
              </FormItem>
            )}
          />

          <div className="mb-4 w-full justify-end flex items-center">
            <Link
              href={"/accounts/password-reset"}
              className="text-sm text-blue-500"
            >
              Olvide mi contraseña
            </Link>
          </div>

          <div className="w-full flex justify-center">
            <Captcha
              onChange={handleCaptcha}
              expireCallback={() => handleCaptcha(null)}
            />
          </div>

          <FormControl className="mt-4">
            <Button
              type="submit"
              className="w-full"
              disabled={isPending || !captchaResolved}
            >
              Iniciar sesion
            </Button>
          </FormControl>
        </form>
      </Form>
    </>
  );
};

export default LoginForm;
